export enum RegistrationTypes {
	SignUp = 'sign_up',
	LogIn = 'log_in',
	ForgotPassword = 'forgot_password',
	ResetPassword = 'reset_password',
}

export enum NameTypes {
	FirstName = 'first',
	LastName = 'last',
}
